var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-toggle-container"},[_c('div',{class:{
      'slide-toggle': true,
      'slide-toggle-active': !!this.value,
    },on:{"click":_vm.onToggle}},[_c('div',{staticClass:"slide-toggle-circle"})]),(_vm.$slots.default)?_c('div',{class:{
      'slide-toggle-label': true,
      'slide-toggle-label-active': !!this.value,
    }},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }